<template>
  <section class="c-points-ledger js-points-ledger is-hidden">


    <div class="c-points-ledger__inner">



      <div class="c-points-ledger__header t-modal-header">
        <h2 class="c-points-ledger__header__title t-modal-header__text">
          {{ $t('web.points_ledger.modal_title') }}
        </h2>
        
        <div class="c-points-ledger__header__close">
          <button
            @click = "togglePointsLedger(false)"
            class  = "c-points-ledger__header__close__button t-modal-header__close"
          >
            <i class="fa fa-close"></i>
          </button>
        </div>
      </div>



      <div class="c-points-ledger__summary">
        <div class="c-points-ledger__summary__balance">
          <h3 class="c-points-ledger__summary__balance__headline">{{ $t('web.points_ledger.points_balance_label') }}</h3>
          <p class="c-points-ledger__summary__balance__headline__number u-number-font">
            {{ typeof participant !== 'undefined' ? formatNumber(participant.points_balance) : '' }}
          </p>
        </div>
        <div  class = "c-points-ledger__summary__redeem"
              v-if = "typeof participant !== 'undefined' ? participant.catalog_is_enabled : false"
        >
          <button
            class  = "c-points-ledger__redeem-button"
            @click = "goToPage('Rewards')"
          >
            {{ $t('web.points_ledger.redeem_button') }}
          </button>
        </div>
      </div>



      <div class="c-points-ledger__body">

        <div
          v-for = "pointsRecord in points.data"
          :key  = "pointsRecord.id"
        >
          <point-record :points-record="pointsRecord"></point-record>
        </div>

        <paginate
          v-show          = "points.total > 0"
          :pagination     = "pagination"
          :pagingCallback = "paginatePoints"
        ></paginate>

      </div>


    </div>


    <div class="c-points-ledger__overlay"></div>


  </section>
</template>



<script>

/* HTML */
import { mapGetters, mapActions } from 'vuex'
import { each, last } from 'lodash'
import util from '@/functions'
import PointsRecord from '@/views/components/PointsRecord'
import Paginate from '@/views/components/shared/Paginate'

export default {
  components: {
    'point-record': PointsRecord,
    'paginate': Paginate
  },
  data () {
    return {
      currentPage: 1,
      perPage: 10
    }
  },
  computed: {
    ...mapGetters([
      'points',
      'participant'
    ]),
    pagination () {
      let totalPages = Math.ceil(this.points.total / this.perPage)
      let pages = util.getPagination(this.currentPage, totalPages)

      let pagination = {
        current: this.currentPage,
        per_page_count: this.perPage,
        count: this.points.total,
        pages: pages
      }

      pagination.previous = (this.currentPage === 1) ? null : this.currentPage - 1
      pagination.next = (this.currentPage === last(pagination.pages)) ? null : this.currentPage + 1

      return pagination
    }
  },
  methods: {
    ...mapActions([
      'LOAD_POINTS_LEDGER'
    ]),
    formatNumber (value) {
      return util.formatNumber(value)
    },
    goToPage (page) {
      util.togglePointsLedger(false)
      this.$router.push({ name: page })
    },
    togglePointsLedger (open) {
      this.currentPage = 1
      util.togglePointsLedger(open)
      this.closePointsRecordsNotes()
    },
    closePointsRecordsNotes () {
      each(this.$children, (child) => {
        child.$data.showNotes = false
      })
    },
    paginatePoints (page) {
      this.currentPage = page

      this.LOAD_POINTS_LEDGER({page: page})
    }

  }
}
</script>


<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// PointsLedger.vue?048c8cda